const getStudentsNotInSpace = ({
  uploadedGrades,
  currentGrades,
  emailColumnIndex,
}) =>
  uploadedGrades
    .slice(1)
    .filter((row) => {
      const uploadedEmail = row[emailColumnIndex];

      // If there is no email then ignore the row
      if (!uploadedEmail || uploadedEmail === '') {
        return false;
      }

      return !currentGrades.find(({ email }) => email === uploadedEmail);
    })
    .map((row) => ({ email: row[emailColumnIndex] }));

export default getStudentsNotInSpace;
